import { useCallback, useEffect, useMemo, useState } from "react"
import { useLogto } from "@logto/react";
import { LOGTO_RESOURCE, LogtoPermission } from "@src/utils/constants";

export const usePermission = () => {
  const [permission, setPermission] = useState(new Set<string>());
  const { isAuthenticated, getAccessTokenClaims } = useLogto();
  useEffect(() => {
    if (!isAuthenticated) return;
    getAccessTokenClaims(LOGTO_RESOURCE).then(data => {
      setPermission(new Set([...data?.scope?.split(' ') || []]));
    });
  }, [isAuthenticated]);
  const isAdmin = useMemo(() => {
    return permission.has(LogtoPermission.ADMIN);
  }, [permission]);
  const hasPermission = useCallback((...permissions: string[]) => {
    if (!permissions.length) return false;
    if (isAdmin) return true;
    const hasPer = permissions.every(v => permission.has(v));
    if (!hasPer) console.debug("No Permission", { request: permissions, permission });
    return hasPer;
  }, [permission, isAdmin]);
  return { permission, isAdmin, hasPermission };
}